import { flow } from 'fp-ts/function';
var formatHours = flow(Math.trunc, function (h) {
  return h === 0 ? '' : h > 0 ? "+".concat(h) : "".concat(h);
});
var utcStringFromOffset = flow(function (offset) {
  return offset * -1;
}, function (off) {
  return [formatHours(off / 60), Math.abs(off % 60)].filter(function (x) {
    return x;
  }).join(':');
}, function (hhmm) {
  return "[UTC".concat(hhmm, "]");
});
export var offsetToUTCString = function offsetToUTCString(_ref) {
  var abbreviation = _ref.abbreviation,
      offset = _ref.offset;
  return [utcStringFromOffset(offset), abbreviation || ''].join(' ');
};